<template functional>
  <div
    :class="[data.staticClass, data.class]"
    class="winner-item"
  >
    <router-link
      :to="props.url"
      class="d-flex py-3 align-items-center"
    >
      <slot name="beforeImg"/>
      <div class="position-relative">
        <icon
          src="@/assets/icons/laurels2.svg"
          class="position-absolute"
          style="top:0; right:1rem"
        />
        <img
          :src="props.image"
          :alt="props.title"
          class="align-self-center rounded-circle mr-3"
        >
      </div>
      <div>
        <slot name="beforeTitle"/>
        <h5 class="text-uppercase mt-0 mb-2">{{ props.title }}</h5>
        <slot>
          <small class="text-dark">{{ props.text }}</small>
        </slot>
      </div>
    </router-link>
    <slot name="after"/>
  </div>
</template>

<script>
export default {
  name: 'WinnerItem'
}
</script>

<style lang="scss">
  @import '../../scss/bootstrap/custom';

  .winner-item {
    //text-align: center;

    & +& {
      border-top: $border-width solid gray('300');
    }

    img {
      width: 5rem;
      height: 5rem;
      background-color: gray('200');
    }

    a {
      transition: $transition-base;
      @include hover-focus() {
        color: theme-color('secondary');
        text-decoration: none;
      }
    }
  }
</style>
